export default "__VITE_PUBLIC_ASSET__3eb5913b__"